import { Trans, t } from '@lingui/macro';

import { useActiveLocale } from 'hooks/useActiveLocale';
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { useSearch } from 'hooks';
import { useQuery } from 'react-query';
import { employeeLaborService } from 'services';
import { useState } from 'react';
import { TableEmpty } from 'components';
import { EnterpriseType } from 'types/Enterprise';
import { getEmployeeType } from 'constants/employee';
import { DateTime } from 'luxon';
import { formatNumber } from 'utils/common';

const EmployeeList = ({ enterprise }: { enterprise?: EnterpriseType }) => {
  const [dataSearch, onSearchChange] = useSearch();
  const userLocale = useActiveLocale();

  const { data } = useQuery(
    ['employeeLaborService.fetchEmployeeLabors', { id: enterprise?.id, ...dataSearch }],
    () => employeeLaborService.fetchEmployeeLabors({ id: enterprise?.id, ...dataSearch }),
    { keepPreviousData: true },
  );
  const { data: items = [], paginate } = data ?? {};

  const [checked, setChecked] = useState([false, false]);

  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, event.target.checked]);
  };

  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], event.target.checked]);
  };

  const childrenTypeCheckbox = (
    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
      <FormControlLabel label='Full-time' control={<Checkbox checked={checked[0]} onChange={handleChange2} />} />
      <FormControlLabel label='Part-time' control={<Checkbox checked={checked[1]} onChange={handleChange3} />} />
    </Box>
  );

  const childrenDivisionCheckbox = (
    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
      <FormControlLabel label='Office Division' control={<Checkbox checked={checked[0]} onChange={handleChange2} />} />
      <FormControlLabel
        label='Manufacturing Division'
        control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
      />
      <FormControlLabel
        label='Management Division'
        control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
      />
      <FormControlLabel label='Other Division 1' control={<Checkbox checked={checked[1]} onChange={handleChange3} />} />
      <FormControlLabel label='Other Division 2' control={<Checkbox checked={checked[1]} onChange={handleChange3} />} />
      <FormControlLabel label='Other Division 3' control={<Checkbox checked={checked[1]} onChange={handleChange3} />} />
    </Box>
  );

  return (
    <div className='mt-4'>
      <div className='flex items-end justify-between'>
        <Typography variant='h4'>
          <Trans>List of Employee</Trans>
        </Typography>
        <div className='space-x-3'>
          <TextField select defaultValue={1}>
            <MenuItem value={1}>
              <Trans>Employee Name</Trans>
            </MenuItem>
            <MenuItem value={2}>
              <Trans>ID No.</Trans>
            </MenuItem>
            <MenuItem value={3}>
              <Trans>Staff ID</Trans>
            </MenuItem>
            <MenuItem value={4}>
              <div>
                <FormControlLabel
                  label='Type'
                  control={
                    <Checkbox
                      checked={checked[0] && checked[1]}
                      indeterminate={checked[0] !== checked[1]}
                      onChange={handleChange1}
                    />
                  }
                />
                {childrenTypeCheckbox}
              </div>
            </MenuItem>
            <MenuItem value={5}>
              <div>
                <FormControlLabel
                  label='Division'
                  control={
                    <Checkbox
                      checked={checked[0] && checked[1]}
                      indeterminate={checked[0] !== checked[1]}
                      onChange={handleChange1}
                    />
                  }
                />
                {childrenDivisionCheckbox}
              </div>
            </MenuItem>
          </TextField>
          <TextField placeholder={t`Search...`} />
        </div>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Trans>Employee Name</Trans>
              </TableCell>
              <TableCell>
                <Trans>ID No.</Trans>
              </TableCell>
              <TableCell>
                <Trans>Staff ID</Trans>
              </TableCell>
              <TableCell>
                <Trans>Type</Trans>
              </TableCell>
              <TableCell>
                <Trans>Division</Trans>
              </TableCell>
              <TableCell>
                <Trans>Attendance Starting Date</Trans>
              </TableCell>
              <TableCell>
                <Trans>Attendance Closing Date</Trans>
              </TableCell>
              <TableCell>
                <Trans>No. of Earned Labour</Trans>
              </TableCell>
              <TableCell>
                <Trans>Latest Updated on</Trans>
              </TableCell>
              <TableCell>
                <Trans>Advanced Labours</Trans>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.employeeId}>
                <TableCell>{item.employee.name}</TableCell>
                <TableCell>{item.employee.ercNumber}</TableCell>
                <TableCell>{item.employeeCode}</TableCell>
                <TableCell>{getEmployeeType(item.employeeType)}</TableCell>
                <TableCell>
                  {userLocale === 'vi-VN' ? item.workingBlock?.viContent : item.workingBlock?.enContent}
                </TableCell>
                <TableCell>{item.fromDate ? DateTime.fromISO(item.fromDate).toFormat('dd/MM/yyyy') : ''}</TableCell>
                <TableCell>{item.toDate ? DateTime.fromISO(item.toDate).toFormat('dd/MM/yyyy') : ''}</TableCell>
                <TableCell>{formatNumber(item.totalLabor)}</TableCell>
                <TableCell>{item.updatedAt ? DateTime.fromISO(item.updatedAt).toFormat('dd/MM/yyyy') : ''}</TableCell>
                <TableCell>{formatNumber(item.advancedLabor)}</TableCell>
              </TableRow>
            ))}
            <TableEmpty data={items} />
          </TableBody>
        </Table>
      </TableContainer>

      <div className='flex justify-center'>
        <Pagination
          page={paginate?.page ?? 1}
          count={paginate?.totalPage}
          onChange={(event, value) => onSearchChange({ page: value })}
        />
      </div>
    </div>
  );
};

export default EmployeeList;
